import { render, staticRenderFns } from "./MagayaLocationModal.vue?vue&type=template&id=4b671d62&scoped=true"
import script from "./MagayaLocationModal.vue?vue&type=script&lang=js"
export * from "./MagayaLocationModal.vue?vue&type=script&lang=js"
import style0 from "./MagayaLocationModal.vue?vue&type=style&index=0&id=4b671d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b671d62",
  null
  
)

export default component.exports